import React, {useState, useEffect, useCallback} from 'react';
import {API_ENDPOINTS} from "../../../apiConfig";
import API from "../../../utils/API";
import moment from 'moment';
import {useTranslation} from 'react-i18next';
import Forms from "../../../components/Forms";
import DeleteIconButton from "../../../components/Forms/DeleteIconButton";
import EditIconButton from "../../../components/Forms/EditIconButton";
import DeviceModal from "../../../components/DeviceModal";
import {useModal} from "../../../contexts/ModalContext";
import AdminDataView from "../../../components/AdminDataView";
import PhotoThumbWithHover from "../../../components/PhotoThumbWithHover";
import {resolveDevicePhotoUrl} from "../../../utils/adminMedia";

const Devices = () => {
    const [devices, setDevices] = useState([]);
    const {t} = useTranslation();
    const {openModal, confirm} = useModal();

    const fetchDevices = useCallback(async () => {
        try {
            const response = await API.get(API_ENDPOINTS.device.list);
            setDevices(response.data);
        } catch (error) {
            console.error("Failed to fetch devices:", error);
        }
    }, []);

    useEffect(() => {
        fetchDevices();
    }, [fetchDevices]);

    const columns = [
        {
            key: 'photo',
            name: 'Fotografie',
            renderCell: ({row}) => <PhotoThumbWithHover src={resolveDevicePhotoUrl(row)} alt={row.name || 'Zařízení'}/>
        },
        {
            key: 'name',
            name: t('name'),
            renderCell: ({row}) => row.name
        },
        {
            key: 'category',
            name: t('category'),
            renderCell: ({row}) => row.category.map(cat => cat.name)
        },
        {
            key: 'repairList',
            name: t('repairList'),
            renderCell: ({row}) => row.repairList.map(repair => repair.repair.name).join(', ')
        },
        {
            key: 'createdBy',
            name: t('createdBy'),
            renderCell: ({row}) => `${row.createdBy.name} ${row.createdBy.surname}`
        },
        {
            key: 'createdAt',
            name: t('createdAt'),
            renderCell: ({row}) => moment(row.createdAt).format('DD.MM.YYYY HH:mm')
        },
        {
            key: 'actions',
            name: 'Akce',
            renderCell: ({row}) => (
                <div className="flex items-center justify-end h-full w-full">
                    <EditIconButton title="Upravit zařízení" onClick={() => openDeviceModal(row)}/>
                    <DeleteIconButton title="Smazat zařízení" onClick={() => confirmDeleteDevice(row)}/>
                </div>
            )
        }
    ].map(column => ({...column, resizable: true}));

    const confirmDeleteDevice = async (device) => {
        const result = await confirm(t('confirmDeviceDeletion').replace('{{device}}', device.name), {});

        if (result === true) {
            try {
                await API.delete(`${API_ENDPOINTS.device.base}/${device._id}`);
                setDevices(devices.filter(category => category._id !== device._id));
            } catch (error) {
                console.error("Failed to delete repair:", error);
            }
        }
    };

    const openDeviceModal = (device) => {
        openModal(DeviceModal, {
            device,
            onDeviceUpdate: fetchDevices
        }, {title: device ? "Úprava zařízení" : "Nové zařízení"});
    }

    return (
        <div>
            <Forms.Button label={t('addDevice')} onClick={() => openDeviceModal()} className="mb-8"/>
            <AdminDataView section="devices" rows={devices} columns={columns} resolvePhotoUrl={resolveDevicePhotoUrl}/>
        </div>
    );
};

export default Devices;
